/* ============================================
   PUMPTHEFUEL - Core Theme JavaScript
   Version 1.0.0
   ============================================ */

(function() {
  'use strict';

  // ─── Loader ───────────────────────────────────────────
  function initLoader() {
    const loader = document.getElementById('ptf-loader');
    if (!loader) return;
    window.addEventListener('load', function() {
      setTimeout(function() {
        loader.classList.add('loaded');
      }, 1400);
    });
  }

  // ─── Scroll Progress Bar ──────────────────────────────
  function initScrollProgress() {
    const bar = document.getElementById('scroll-progress');
    if (!bar) return;
    function update() {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const pct = max > 0 ? (window.scrollY / max * 100) : 0;
      bar.style.width = pct + '%';
    }
    window.addEventListener('scroll', update, { passive: true });
  }

  // ─── Sticky Header ────────────────────────────────────
  function initStickyHeader() {
    const header = document.querySelector('.site-header');
    if (!header) return;
    function onScroll() {
      header.classList.toggle('scrolled', window.scrollY > 20);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // ─── Custom Cursor (desktop only) ─────────────────────
  function initCursor() {
    if (window.innerWidth < 1024) return;
    const dot = document.querySelector('.cursor-dot');
    const ring = document.querySelector('.cursor-ring');
    if (!dot || !ring) return;

    let mouseX = 0, mouseY = 0;
    let ringX = 0, ringY = 0;
    let rafId;

    document.addEventListener('mousemove', function(e) {
      mouseX = e.clientX;
      mouseY = e.clientY;
      dot.style.left = mouseX + 'px';
      dot.style.top = mouseY + 'px';
    });

    function animateRing() {
      ringX += (mouseX - ringX) * 0.12;
      ringY += (mouseY - ringY) * 0.12;
      ring.style.left = (ringX - 16) + 'px';
      ring.style.top = (ringY - 16) + 'px';
      rafId = requestAnimationFrame(animateRing);
    }
    animateRing();

    document.querySelectorAll('a, button, .btn, .card, .product-card').forEach(function(el) {
      el.addEventListener('mouseenter', function() {
        ring.style.width = '52px';
        ring.style.height = '52px';
        ring.style.borderColor = 'rgba(0,200,150,0.8)';
        dot.style.transform = 'scale(2)';
      });
      el.addEventListener('mouseleave', function() {
        ring.style.width = '32px';
        ring.style.height = '32px';
        ring.style.borderColor = 'rgba(0,200,150,0.5)';
        dot.style.transform = 'scale(1)';
      });
    });
  }

  // ─── Scroll Reveal (Intersection Observer) ────────────
  function initScrollReveal() {
    const elements = document.querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-scale');
    if (!elements.length) return;

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    elements.forEach(function(el) { observer.observe(el); });
  }

  // ─── Parallax Effects ─────────────────────────────────
  function initParallax() {
    const layers = document.querySelectorAll('[data-parallax]');
    if (!layers.length) return;

    function onScroll() {
      const scrollY = window.scrollY;
      layers.forEach(function(layer) {
        const speed = parseFloat(layer.dataset.parallax) || 0.3;
        const rect = layer.closest('section') ? layer.closest('section').getBoundingClientRect() : layer.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < window.innerHeight) {
          const offset = scrollY * speed;
          layer.style.transform = 'translateY(' + offset + 'px)';
        }
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // ─── Particle Canvas Background ──────────────────────
  function initParticles(canvasId) {
    const canvas = document.getElementById(canvasId);
    if (!canvas) return;
    const ctx = canvas.getContext('2d');

    function resize() {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    }
    resize();
    window.addEventListener('resize', resize);

    const particles = [];
    const count = Math.min(60, Math.floor(canvas.width * canvas.height / 15000));

    for (let i = 0; i < count; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        vx: (Math.random() - 0.5) * 0.4,
        vy: (Math.random() - 0.5) * 0.4,
        r: Math.random() * 1.5 + 0.5,
        alpha: Math.random() * 0.5 + 0.1,
        color: Math.random() > 0.6 ? '#00c896' : '#00e5ff'
      });
    }

    function draw() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Draw connections
      particles.forEach(function(p, i) {
        for (let j = i + 1; j < particles.length; j++) {
          const q = particles[j];
          const dist = Math.hypot(p.x - q.x, p.y - q.y);
          if (dist < 100) {
            const alpha = (1 - dist / 100) * 0.15;
            ctx.beginPath();
            ctx.strokeStyle = 'rgba(0,200,150,' + alpha + ')';
            ctx.lineWidth = 0.5;
            ctx.moveTo(p.x, p.y);
            ctx.lineTo(q.x, q.y);
            ctx.stroke();
          }
        }
      });

      // Draw particles
      particles.forEach(function(p) {
        p.x += p.vx;
        p.y += p.vy;
        if (p.x < 0 || p.x > canvas.width) p.vx *= -1;
        if (p.y < 0 || p.y > canvas.height) p.vy *= -1;

        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = p.color;
        ctx.globalAlpha = p.alpha;
        ctx.fill();
        ctx.globalAlpha = 1;
      });

      requestAnimationFrame(draw);
    }
    draw();
  }

  // ─── Number Counter Animation ─────────────────────────
  function initCounters() {
    const counters = document.querySelectorAll('[data-count]');
    if (!counters.length) return;

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const target = parseInt(el.dataset.count);
        const suffix = el.dataset.suffix || '';
        const duration = 2000;
        const start = performance.now();

        function update(now) {
          const progress = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = Math.round(eased * target) + suffix;
          if (progress < 1) requestAnimationFrame(update);
        }
        requestAnimationFrame(update);
        observer.unobserve(el);
      });
    }, { threshold: 0.5 });

    counters.forEach(function(el) { observer.observe(el); });
  }

  // ─── Mobile Navigation ────────────────────────────────
  function initMobileNav() {
    const burger = document.querySelector('.hamburger');
    const mobileNav = document.querySelector('.mobile-nav');
    const mobileClose = document.querySelector('.mobile-nav-close');
    if (!burger || !mobileNav) return;

    burger.addEventListener('click', function() {
      burger.classList.toggle('open');
      mobileNav.classList.toggle('open');
      document.body.style.overflow = mobileNav.classList.contains('open') ? 'hidden' : '';
    });

    if (mobileClose) {
      mobileClose.addEventListener('click', function() {
        burger.classList.remove('open');
        mobileNav.classList.remove('open');
        document.body.style.overflow = '';
      });
    }

    // Close on link click
    mobileNav.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        burger.classList.remove('open');
        mobileNav.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  // ─── Button Ripple Effect ─────────────────────────────
  function initRipple() {
    document.querySelectorAll('.btn--primary, .btn--secondary').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        const rect = btn.getBoundingClientRect();
        const ripple = document.createElement('span');
        const size = Math.max(rect.width, rect.height);
        ripple.className = 'btn-ripple';
        ripple.style.width = ripple.style.height = size + 'px';
        ripple.style.left = (e.clientX - rect.left - size / 2) + 'px';
        ripple.style.top = (e.clientY - rect.top - size / 2) + 'px';
        btn.appendChild(ripple);
        setTimeout(function() { ripple.remove(); }, 700);
      });
    });
  }

  // ─── Tabs Component ──────────────────────────────────
  function initTabs() {
    document.querySelectorAll('[data-tabs]').forEach(function(container) {
      const tabs = container.querySelectorAll('[data-tab]');
      const panels = container.querySelectorAll('[data-tab-panel]');

      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          const target = tab.dataset.tab;
          tabs.forEach(function(t) { t.classList.remove('active'); });
          panels.forEach(function(p) { p.classList.remove('active'); });
          tab.classList.add('active');
          const panel = container.querySelector('[data-tab-panel="' + target + '"]');
          if (panel) panel.classList.add('active');
        });
      });
    });
  }

  // ─── Announcement Bar Slider ─────────────────────────
  function initAnnouncementSlider() {
    const track = document.querySelector('.announcement-track');
    if (!track) return;
    // Duplicate items for infinite scroll
    track.innerHTML += track.innerHTML;
  }

  // ─── Product Image Hover Zoom ─────────────────────────
  function initProductHover() {
    document.querySelectorAll('.product-card__image-wrap').forEach(function(wrap) {
      const img = wrap.querySelector('img');
      if (!img) return;
      wrap.addEventListener('mouseenter', function() {
        img.style.transform = 'scale(1.08)';
      });
      wrap.addEventListener('mouseleave', function() {
        img.style.transform = 'scale(1)';
      });
    });
  }

  // ─── Sticky Add to Cart ───────────────────────────────
  function initStickyATC() {
    const sticky = document.querySelector('.sticky-atc');
    const hero = document.querySelector('.product-hero');
    if (!sticky || !hero) return;

    const observer = new IntersectionObserver(function(entries) {
      sticky.classList.toggle('visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    observer.observe(hero);
  }

  // ─── Newsletter Form ──────────────────────────────────
  function initNewsletterForm() {
    document.querySelectorAll('.newsletter-form').forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        const btn = form.querySelector('button[type="submit"]');
        const input = form.querySelector('input[type="email"]');
        if (!btn || !input || !input.value) return;
        btn.textContent = 'Subscribing...';
        btn.disabled = true;
        // Shopify form will handle actual submission
        setTimeout(function() {
          btn.textContent = '✓ Subscribed!';
          input.value = '';
          setTimeout(function() {
            btn.textContent = 'Subscribe';
            btn.disabled = false;
          }, 3000);
        }, 1000);
      });
    });
  }

  // ─── Smooth Anchor Links ──────────────────────────────
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
      anchor.addEventListener('click', function(e) {
        const target = document.querySelector(this.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  // ─── Quantity Selector ────────────────────────────────
  function initQuantitySelectors() {
    document.querySelectorAll('.qty-selector').forEach(function(selector) {
      const minus = selector.querySelector('[data-qty-minus]');
      const plus = selector.querySelector('[data-qty-plus]');
      const input = selector.querySelector('input');
      if (!minus || !plus || !input) return;

      minus.addEventListener('click', function() {
        const val = parseInt(input.value) || 1;
        if (val > 1) input.value = val - 1;
      });

      plus.addEventListener('click', function() {
        const val = parseInt(input.value) || 1;
        input.value = val + 1;
      });
    });
  }

  // ─── Image Lazy Load ─────────────────────────────────
  function initLazyImages() {
    if ('IntersectionObserver' in window) {
      const imgs = document.querySelectorAll('img[data-src]');
      const io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            const img = entry.target;
            img.src = img.dataset.src;
            if (img.dataset.srcset) img.srcset = img.dataset.srcset;
            img.removeAttribute('data-src');
            io.unobserve(img);
          }
        });
      }, { rootMargin: '200px' });
      imgs.forEach(function(img) { io.observe(img); });
    }
  }

  // ─── Testimonial Slider ───────────────────────────────
  function initTestimonialSlider() {
    const sliders = document.querySelectorAll('[data-slider]');
    sliders.forEach(function(slider) {
      const track = slider.querySelector('[data-slider-track]');
      const items = track ? track.querySelectorAll('[data-slide]') : [];
      const prev = slider.querySelector('[data-slider-prev]');
      const next = slider.querySelector('[data-slider-next]');
      const dots = slider.querySelectorAll('[data-slider-dot]');
      if (!track || !items.length) return;

      let current = 0;

      function go(n) {
        current = (n + items.length) % items.length;
        track.style.transform = 'translateX(-' + current * 100 + '%)';
        dots.forEach(function(d, i) { d.classList.toggle('active', i === current); });
      }

      if (prev) prev.addEventListener('click', function() { go(current - 1); });
      if (next) next.addEventListener('click', function() { go(current + 1); });
      dots.forEach(function(d, i) { d.addEventListener('click', function() { go(i); }); });

      // Auto-play
      setInterval(function() { go(current + 1); }, 5000);
    });
  }

  // ─── Init All ─────────────────────────────────────────
  function init() {
    initLoader();
    initScrollProgress();
    initStickyHeader();
    initCursor();
    initScrollReveal();
    initParallax();
    initCounters();
    initMobileNav();
    initRipple();
    initTabs();
    initAnnouncementSlider();
    initProductHover();
    initStickyATC();
    initNewsletterForm();
    initSmoothScroll();
    initQuantitySelectors();
    initLazyImages();
    initTestimonialSlider();

    // Init particles if canvas present
    if (document.getElementById('hero-canvas')) {
      initParticles('hero-canvas');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose globally for section-specific use
  window.PTF = {
    initParticles: initParticles,
    initScrollReveal: initScrollReveal,
    initCounters: initCounters
  };

})();
